// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  display: none !important;
}

.no-padding {
  padding: 0 !important;
}

.left-col {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

.right-col {
  padding-right: 0 !important;
  padding-left: 5px !important;
}

.info-text-medium {
  font-size: var(--font-size-medium) !important;
}

.info-text-small {
  font-size: var(--font-size-small) !important;
}

.avatar-fab {
  margin: 5px 0;
  position: absolute;
  bottom: 0;
  right: 5px;
}
.avatar-fab ion-fab-button {
  width: 100%;
  height: 100%;
}
.avatar-fab ion-icon {
  width: 50%;
  height: 50%;
}

.fab {
  margin: 5px 0;
}
.fab ion-fab-button {
  width: 100%;
  height: 100%;
}
.fab ion-icon {
  width: 50%;
  height: 50%;
}

.text-warning {
  color: var(--ion-color-warning);
}

.text-danger {
  color: var(--ion-color-danger);
}

.sub-operator-info-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  border-radius: 5px;
}

.sub-operator-info-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 5px;
}

.sub-operator-info-row {
  width: 100%;
}
.sub-operator-info-row ion-col {
  height: 100%;
}

.sub-operator-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}

.sub-operator-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.actions-fab-col {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: right;
}

.address-info-row {
  width: 100%;
  height: 7.5%;
}

.address-info-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 5px;
  margin: 0;
  border-radius: 5px;
}

.address-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5;
}

.address-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
}

.other-info-row {
  width: 100%;
  height: 7.5%;
}

.other-info-col-left {
  padding: 0 5px 0 0;
  height: 100%;
}

.other-info-col-right {
  padding: 0 0 0 5px;
  height: 100%;
}

.id-info-card {
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 5px;
  margin: 0;
  border-radius: 5px;
}

.id-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.id-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
}

.mocca-info-card {
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 5px;
  margin: 0;
  border-radius: 5px;
}

.mocca-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.mocca-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
}

.representative-info-row {
  width: 100%;
}

.representative-info-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin: 0;
  border-radius: 5px;
  gap: 5px;
}
.representative-info-card .address-info-row {
  height: 25%;
}
.representative-info-card .other-info-row {
  height: 25%;
}

.representative-info-col {
  display: flex;
  justify-content: left;
  align-items: left;
}

.representative-text-row {
  width: 100%;
  height: 50%;
}

.representative-info-col {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
}

.representative-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
  height: -moz-fit-content;
  height: fit-content;
}

.associated-vehicles-col {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.associated-vehicles-card {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.associated-vehicles-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 12%;
  padding: 5px;
}

.associated-vehicles-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.associated-vehicles-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
}

.associated-vehicles-card-content {
  width: 100%;
  height: 100%;
  flex: 1;
  overflow-y: auto;
  padding: 5px;
  gap: 10px;
  min-height: 0;
  justify-content: center;
}

.associated-pilots-col {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.associated-pilots-card {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.associated-pilots-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 12%;
  padding: 5px;
}

.associated-pilots-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.associated-pilots-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
}

.associated-pilots-card-content {
  width: 100%;
  height: 100%;
  flex: 1;
  overflow-y: auto;
  padding: 5px;
  gap: 10px;
  min-height: 0;
  justify-content: center;
}

.vehicle-item-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-width: 0;
  padding: 5px 10px;
  align-items: center;
  width: 100%;
}

.vehicle-info-col {
  display: flex;
  flex-direction: column;
  margin-left: 1vw;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.vehicle-info-col ion-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

.pilot-item-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-width: 0;
  padding: 5px 10px;
  align-items: center;
  width: 100%;
}

.pilot-info-col {
  display: flex;
  flex-direction: column;
  margin-left: 1vw;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.pilot-info-col ion-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

.droneIcon {
  width: var(--icon-size-large);
  height: var(--icon-size-large);
  flex: 0 0 auto;
}

.vehicles-pilots-row {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: row;
}

.vehicles-pilots-col-right {
  padding: 0;
  padding-left: 5px;
  height: 100%;
}

.vehicles-pilots-col-left {
  padding: 0;
  padding-right: 5px;
  height: 100%;
}

.card-icon {
  cursor: pointer;
}

.vehicle-card {
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.vehicle-card:hover {
  border-color: var(--ion-color-primary);
  box-shadow: var(--shadow-primary-sm);
}

.pilot-card {
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.pilot-card:hover {
  border-color: var(--ion-color-primary);
  box-shadow: var(--shadow-primary-sm);
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  .fab {
    width: 25px;
    height: 25px;
  }
  .avatar-fab {
    width: 15px;
    height: 15px;
  }
  .card-icon {
    font-size: 20px;
  }
  .info-text {
    font-size: var(--font-size-small);
  }
  .representative-info-row {
    height: 30%;
  }
  .sub-operator-info-row {
    height: 25%;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  .fab {
    width: 35px;
    height: 35px;
  }
  .avatar-fab {
    width: 25px;
    height: 25px;
  }
  .card-icon {
    font-size: 25px;
  }
  .info-text {
    font-size: var(--font-size-small);
  }
  .representative-info-row {
    height: 25%;
  }
  .sub-operator-info-row {
    height: 20%;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  .fab {
    width: 45px;
    height: 45px;
  }
  .avatar-fab {
    width: 35px;
    height: 35px;
  }
  .card-icon {
    font-size: 35px;
  }
  .info-text {
    font-size: var(--font-size-medium);
  }
  .representative-info-row {
    height: 28%;
  }
  .sub-operator-info-row {
    height: 17%;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/fleet/components/sub-operators-info-card/sub-operator-info-card.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,2BAAA;EACA,4BAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA;EAEE,aAAA;EAEA,kBAAA;EACA,SAAA;EACA,UAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;AADJ;AAIE;EACE,UAAA;EACA,WAAA;AAFJ;;AAMA;EAEE,aAAA;AAJF;AAME;EACE,WAAA;EACA,YAAA;AAJJ;AAOE;EACE,UAAA;EACA,WAAA;AALJ;;AASA;EACE,+BAAA;AANF;;AAQA;EACE,8BAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;AALF;;AAQA;EACE,WAAA;AALF;AAOE;EACE,YAAA;AALJ;;AASA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AANF;;AASA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;AANF;;AASA;EACE,kBAAA;EACA,YAAA;AANF;;AASA;EACE,kBAAA;EACA,YAAA;AANF;;AASA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AANF;;AASA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AANF;;AASA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;AANF;AAQE;EACE,WAAA;AANJ;AASE;EACE,WAAA;AAPJ;;AAWA;EACE,aAAA;EACA,qBAAA;EACA,iBAAA;AARF;;AAWA;EACE,WAAA;EACA,WAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AARF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AARF;;AAWA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AARF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AARF;;AAWA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;AARF;AAUE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;AATF;AAWE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AATJ;;AAaA;EACE,6BAAA;EACA,8BAAA;EAEA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;AAXF;;AAcA;EACE,UAAA;EACA,iBAAA;EACA,YAAA;AAXF;;AAcA;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,eAAA;EACA,6BAAA;EACA,8CAAA;AAXF;AAaE;EACE,sCAAA;EACA,oCAAA;AAXJ;;AAeA;EACE,eAAA;EACA,6BAAA;EACA,8CAAA;AAZF;AAcE;EACE,sCAAA;EACA,oCAAA;AAZJ;;AAiBA,sEAAA;AAEE,wBAAA;AAEE,2DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAhBN;EAmBI;IACE,WAAA;IACA,YAAA;EAjBN;EAoBI;IACE,eAAA;EAlBN;EAqBI;IACE,iCAAA;EAnBN;EAsBI;IACE,WAAA;EApBN;EAuBI;IACE,WAAA;EArBN;AACF;AAwBE,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAxBN;EA2BI;IACE,WAAA;IACA,YAAA;EAzBN;EA4BI;IACE,eAAA;EA1BN;EA6BI;IACE,iCAAA;EA3BN;EA8BI;IACE,WAAA;EA5BN;EA+BI;IACE,WAAA;EA7BN;AACF;AAgCE,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAhCN;EAmCI;IACE,WAAA;IACA,YAAA;EAjCN;EAoCI;IACE,eAAA;EAlCN;EAqCI;IACE,kCAAA;EAnCN;EAsCI;IACE,WAAA;EApCN;EAuCI;IACE,WAAA;EArCN;AACF;AAwCE,4BAAA","sourcesContent":[".hidden {\r\n  display: none !important;\r\n}\r\n\r\n.no-padding {\r\n  padding: 0 !important;\r\n}\r\n\r\n.left-col {\r\n  padding-left: 0 !important;\r\n  padding-right: 5px !important;\r\n}\r\n\r\n.right-col {\r\n  padding-right: 0 !important;\r\n  padding-left: 5px !important;\r\n}\r\n\r\n.info-text-medium {\r\n  font-size: var(--font-size-medium) !important;\r\n}\r\n\r\n.info-text-small {\r\n  font-size: var(--font-size-small) !important;\r\n}\r\n\r\n.avatar-fab {\r\n\r\n  margin: 5px 0;\r\n\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 5px;\r\n\r\n  ion-fab-button {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  ion-icon {\r\n    width: 50%;\r\n    height: 50%;\r\n  }\r\n}\r\n\r\n.fab {\r\n\r\n  margin: 5px 0;\r\n\r\n  ion-fab-button {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  ion-icon {\r\n    width: 50%;\r\n    height: 50%;\r\n  }\r\n}\r\n\r\n.text-warning {\r\n  color: var(--ion-color-warning);\r\n}\r\n.text-danger {\r\n  color: var(--ion-color-danger);\r\n}\r\n\r\n.sub-operator-info-card{\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.sub-operator-info-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 10px;\r\n  gap: 5px;\r\n}\r\n\r\n.sub-operator-info-row {\r\n  width: 100%;\r\n\r\n  ion-col {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.sub-operator-avatar {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.avatar-image {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n  object-position: center;\r\n}\r\n\r\n.sub-operator-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.actions-fab-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: right;\r\n}\r\n\r\n.address-info-row {\r\n  width: 100%;\r\n  height: 7.5%;\r\n}\r\n\r\n.address-info-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding: 5px;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.address-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0 5;\r\n}\r\n\r\n.address-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.other-info-row {\r\n  width: 100%;\r\n  height: 7.5%;\r\n}\r\n\r\n.other-info-col-left {\r\n  padding: 0 5px 0 0;\r\n  height: 100%;\r\n}\r\n\r\n.other-info-col-right {\r\n  padding: 0 0 0 5px;\r\n  height: 100%;\r\n}\r\n\r\n.id-info-card {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding: 5px;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.id-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.id-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.mocca-info-card {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding: 5px;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.mocca-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.mocca-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: left;\r\n}\r\n\r\n.representative-info-row {\r\n  width: 100%;\r\n}\r\n\r\n.representative-info-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 5px;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n  gap: 5px;\r\n\r\n  .address-info-row {\r\n    height: 25%;\r\n  }\r\n\r\n  .other-info-row {\r\n    height: 25%;\r\n  }\r\n}\r\n\r\n.representative-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: left;\r\n}\r\n\r\n.representative-text-row {\r\n  width: 100%;\r\n  height: 50%;\r\n}\r\n\r\n.representative-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: left;\r\n  align-items: left;\r\n}\r\n\r\n.representative-title {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items:center;\r\n  justify-content: right;\r\n  height: fit-content;\r\n}\r\n\r\n.associated-vehicles-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n}\r\n\r\n.associated-vehicles-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.associated-vehicles-card-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  height: 12%;\r\n  padding: 5px;\r\n}\r\n\r\n.associated-vehicles-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.associated-vehicles-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.associated-vehicles-card-content {\r\n  width: 100%;\r\n  height: 100%;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n  gap: 10px;\r\n  min-height: 0;\r\n  justify-content: center;\r\n}\r\n\r\n.associated-pilots-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n}\r\n\r\n.associated-pilots-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.associated-pilots-card-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  height: 12%;\r\n  padding: 5px;\r\n}\r\n\r\n.associated-pilots-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.associated-pilots-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n}\r\n\r\n.associated-pilots-card-content {\r\n  width: 100%;\r\n  height: 100%;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n  gap: 10px;\r\n  min-height: 0;\r\n  justify-content: center;\r\n}\r\n\r\n.vehicle-item-row {\r\n  display:flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  min-width: 0;\r\n  padding: 5px 10px;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.vehicle-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 1vw;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n\r\n  ion-label {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.pilot-item-row {\r\n  display:flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  min-width: 0;\r\n  padding: 5px 10px;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.pilot-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 1vw;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n\r\n  ion-label {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.droneIcon {\r\n  width: var(--icon-size-large);\r\n  height: var(--icon-size-large);\r\n\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.vehicles-pilots-row {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  flex-direction: row;\r\n}\r\n\r\n.vehicles-pilots-col-right {\r\n  padding: 0;\r\n  padding-left: 5px;\r\n  height: 100%;\r\n}\r\n\r\n.vehicles-pilots-col-left {\r\n  padding: 0;\r\n  padding-right: 5px;\r\n  height: 100%;\r\n}\r\n\r\n.card-icon {\r\n  cursor: pointer;\r\n}\r\n\r\n.vehicle-card {\r\n  cursor: pointer;\r\n  border: 2px solid transparent; // Add this line - initial transparent border\r\n  transition: border-color 0.2s, box-shadow 0.2s; // Add smooth transition\r\n\r\n  &:hover {\r\n    border-color: var(--ion-color-primary);\r\n    box-shadow: var(--shadow-primary-sm);\r\n  }\r\n}\r\n\r\n.pilot-card {\r\n  cursor: pointer;\r\n  border: 2px solid transparent; // Add this line - initial transparent border\r\n  transition: border-color 0.2s, box-shadow 0.2s; // Add smooth transition\r\n\r\n  &:hover {\r\n    border-color: var(--ion-color-primary);\r\n    box-shadow: var(--shadow-primary-sm);\r\n  }\r\n}\r\n\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n  /*#region Small Screens*/\r\n\r\n    /* Styles for screens smaller than 800px wide or 550 high */\r\n    @media (max-width: 599px) {\r\n      .fab {\r\n        width: 25px;\r\n        height: 25px;\r\n      }\r\n\r\n      .avatar-fab {\r\n        width: 15px;\r\n        height: 15px;\r\n      }\r\n\r\n      .card-icon {\r\n        font-size: 20px;\r\n      }\r\n\r\n      .info-text {\r\n        font-size: var(--font-size-small);\r\n      }\r\n\r\n      .representative-info-row {\r\n        height: 30%;\r\n      }\r\n\r\n      .sub-operator-info-row {\r\n        height: 25%;\r\n      }\r\n    }\r\n\r\n  /*#endregion Small Screens*/\r\n\r\n  /*#region Medium Screens*/\r\n\r\n    /* Styles for medium screens with min with of 800px and min height of 550px */\r\n    @media (min-width: 600px) and (max-width: 1023px) {\r\n      .fab {\r\n        width: 35px;\r\n        height: 35px;\r\n      }\r\n\r\n      .avatar-fab {\r\n        width: 25px;\r\n        height: 25px;\r\n      }\r\n\r\n      .card-icon {\r\n        font-size: 25px;\r\n      }\r\n\r\n      .info-text {\r\n        font-size: var(--font-size-small);\r\n      }\r\n\r\n      .representative-info-row {\r\n        height: 25%;\r\n      }\r\n\r\n      .sub-operator-info-row {\r\n        height: 20%;\r\n      }\r\n    }\r\n\r\n  /*#endregion Medium Screens*/\r\n\r\n  /*#region Larger Screens*/\r\n\r\n    /* Styles for screens larger than 1000px wide and 600px high */\r\n    @media (min-width: 1024px) {\r\n      .fab {\r\n        width: 45px;\r\n        height: 45px;\r\n      }\r\n\r\n      .avatar-fab {\r\n        width: 35px;\r\n        height: 35px;\r\n      }\r\n\r\n      .card-icon {\r\n        font-size: 35px;\r\n      }\r\n\r\n      .info-text {\r\n        font-size: var(--font-size-medium);\r\n      }\r\n\r\n      .representative-info-row {\r\n        height: 28%;\r\n      }\r\n\r\n      .sub-operator-info-row {\r\n        height: 17%;\r\n      }\r\n    }\r\n\r\n  /*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
